// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"506":"787c9d87","510":"48b4ae42","609":"256a615d","752":"2957a5e8","923":"3e0e4b91","972":"8cd4519b"}[chunkId] + ".css";
};